/* eslint-disable */

import {
  Flex,
  Box,
  Image,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { useTranslation } from 'react-i18next';

const columnHelper = createColumnHelper();

export default function CheckTable(props) {
  const { t } = useTranslation();
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          {t('dashboard.videoTitle')}
        </Text>
        <Menu />
      </Flex>
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
      <video width="100%" controls>
        <source src={`${process.env.PUBLIC_URL}/video/cvm.mp4`} type="video/mp4" />
        {t('dashboard.videoNotSupported')}
      </video>
    </Box>
    </Card>
  );
}
